import { render, staticRenderFns } from "./SSDACourse.vue?vue&type=template&id=6602eae4&scoped=true"
import script from "./SSDACourse.vue?vue&type=script&lang=js"
export * from "./SSDACourse.vue?vue&type=script&lang=js"
import style0 from "./SSDACourse.vue?vue&type=style&index=0&id=6602eae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6602eae4",
  null
  
)

export default component.exports